import React from "react"
import { BigNumber } from "ethers"
import { formatUnits } from "ethers/lib/utils"
import { useSelector } from "react-redux"
import { AppState } from "src/state"
import { calculatePrice } from "src/utils"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import Text from "./Text"
import { FER } from "src/constants"

interface Props {
  amount: BigNumber
  alignRight?: boolean
}

const FerroPriceText = ({ amount, alignRight }: Props) => {
  const price = useSelector(
    (state: AppState) => state.application.ferro?.price ?? 0,
  )

  return (
    <Text
      size="micro"
      color="#ADADAD"
      mt={0.5}
      textAlign={alignRight ? "right" : "start"}
    >
      ~
      {formatNumber(
        formatUnits(calculatePrice(amount, price, 18), FER.decimals),
        2,
        6,
      )}{" "}
      USD
    </Text>
  )
}

export default FerroPriceText
